/* eslint-disable prefer-destructuring */
import styled from "styled-components";
import * as CommonBasketButtonStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/components/BasketButton";
import { theme as toyotaTheme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as ButtonStyles from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import * as CashPrice from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import * as MonthlyPrice from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import { focusStyle } from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/Focus";

export const BasketTrigger = styled.button`
    display: block;
    position: absolute;
    top: -15px;
    left: 50%;
    width: 30px;
    height: 30px;
    text-align: center;
    background: ${toyotaTheme.colors.primaryWhite};
    border: 1px solid ${toyotaTheme.colors.grey2};
    border-radius: 50%;
    transform: translateX(${({ theme }) => (theme.isRTL ? "50%" : "-50%")});
    .icon::before {
        /* fixes alignment of icon since not centered in icon font */
        position: relative;
        top: -1px;
    }

    ${focusStyle};

    html[dir="rtl"] & {
        left: auto;
        right: 50%;
    }
`;

export const Button = styled.button`
    display: block;
    position: relative;
    width: 42px;
    min-width: 42px;
    height: 42px;
    background-color: ${toyotaTheme.colors.primaryWhite};
    border: 2px solid ${toyotaTheme.colors.primaryBlack};
    border-radius: 50%;
    svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    ${focusStyle};

    .bz & {
        color: ${toyotaTheme.colors.bz4x};
        border-color: ${toyotaTheme.colors.bz4x};
    }
`;

export const BasketCounter = styled.span`
    display: block;
    position: absolute;
    top: -8px;
    right: -4px;
    min-width: 22px;
    height: 16px;
    padding: 0 4px;
    font-family: ${toyotaTheme.fonts.semiBold};
    font-size: 1.1rem;
    line-height: 1.5rem;
    text-align: center;
    color: ${toyotaTheme.colors.primaryWhite};
    background: ${toyotaTheme.colors.primaryBlack};
    border-radius: 10px;

    html[dir="rtl"] & {
        left: -4px;
        right: auto;
    }
`;

export const IconBadge = CommonBasketButtonStyles.IconBadge;

export const MobileBasket = CommonBasketButtonStyles.MobileBasket;

export const BasketTitle = CommonBasketButtonStyles.BasketTitle;

export const MobileBasketHeader = styled.div`
    display: flex;
    padding: 15px 0 ${toyotaTheme.space[3]}px;
    color: ${toyotaTheme.colors.primaryWhite};
`;

export const MobileHeaderWrapper = styled.div`
    margin-bottom: -1px; /* fixes browser rendering issue */
    padding: ${toyotaTheme.space[3]}px ${toyotaTheme.space[3]}px 0;
    background: ${toyotaTheme.colors.primaryWhite};
`;

export const CloseMobileBasket = styled.button`
    width: auto;
    margin-left: auto;
    margin-right: -6px;
    color: ${toyotaTheme.colors.primaryWhite};
    background: transparent;
    border: 0;

    html[dir="rtl"] & {
        margin-left: -6px;
        margin-right: auto;
    }
`;

export const Pricing = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-left: 12px;
    font-size: 1.3rem;
    line-height: 2rem;
    ${MonthlyPrice.Text} {
        font-family: ${toyotaTheme.fonts.semiBold};
        font-size: 1.3rem;
        line-height: 2rem;
        color: ${toyotaTheme.colors.primaryBlack};
    }
    ${CashPrice.Text} {
        margin-top: 0;
        font-family: ${toyotaTheme.fonts.regular};
        font-size: 1.3rem;
        line-height: 2rem;
        color: ${toyotaTheme.colors.primaryBlack};

        span:not(:nth-last-child(1)) {
            display: inline-block;
        }

        span:first-child:not(:nth-last-child(1)) {
            margin-left: ${toyotaTheme.space[1]}px;
        }
    }
    ${ButtonStyles.Link} {
        flex-direction: row-reverse;
        align-items: center;
        color: ${toyotaTheme.colors.primaryBlack};
        .icon::before {
            /* fix bad icon alignment */
            position: relative;
            top: 1px;
            color: ${toyotaTheme.colors.grey4};
        }
        ${IconWrapper} {
            margin-left: 0;
            margin-right: ${toyotaTheme.space[1]}px;
        }
        ${Type.SmallText} {
            text-align: start;
        }
    }
    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: 12px;
        ${ButtonStyles.Link} {
            ${IconWrapper} {
                margin-left: ${toyotaTheme.space[1]}px;
                margin-right: 0;
            }
        }
    }
`;

export const Wrapper = styled.div`
    display: flex;
    flex: 2 0 fit-content;
    justify-content: flex-start;
    margin-right: auto;

    html[dir="rtl"] & {
        margin-left: auto;
        margin-right: 0;
    }
`;

export const FinanceTitle = styled.span`
    font-family: ${toyotaTheme.fonts.regular};
    font-size: 1.2rem;
`;
